import React, { useState, useEffect } from 'react';
import { API_DOMAIN } from './globals'; // Import the global domain name

function Passbook() {
    const [MyPassbook, setMyPassbook] = useState([]); // Store the API response
    const [MyLedgerBook, setMyLedgerBook] = useState([]); // Store the ledger data
    const [totalDebit, setTotalDebit] = useState(0); // Total debit
    const [totalCredit, setTotalCredit] = useState(0); // Total credit
    const [Balance, setBalance] = useState(0); // Balance
    const [Received, setReceived] = useState(0); // Total received
    const [Paid, setPaid] = useState(0); // Total paid
    const [Profit, setProfit] = useState(0); // Total profit
    const [Loss, setLoss] = useState(0); // Total loss

    const [expandedRows, setExpandedRows] = useState({}); // Track expanded rows
    const [loading, setLoading] = useState(true); // Loading state
    const [error, setError] = useState(null); // Error state

    useEffect(() => {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        //link.href = `${process.env.PUBLIC_URL}/static/css/Passbook.css`;
        document.head.appendChild(link);
        
        // Define your parameters
        const param1 = sessionStorage.getItem("UserType");
        const param2 = sessionStorage.getItem("UserName");

        // Create query string
        const queryString = new URLSearchParams({ ut: param1, un: param2 }).toString();
        const url = `${API_DOMAIN}/api/Client/getMyPassbookNew.php?${queryString}`;

        
        // Fetch data
        fetch(url, {
            method: 'GET',
            credentials: 'include', // Send cookies with the request
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => response.json())
            .then((data) => {
                if(data.Status=="Error") {
                    sessionStorage.setItem("LogoutMsg",data.Message)
                    window.location = '/';
                } else {
                    setMyPassbook(data.data);
                    setMyLedgerBook(data.data);

                    if (data.data.length > 0) {
                        setTotalDebit(data.data[0].TotDebit);
                        setTotalCredit(data.data[0].TotCredit);
                        setBalance(-data.data[0].Balance);
                        calculatePassbookBalance(data.data, data.ledger);
                    }
                }

                setLoading(false);
            })
            .catch((err) => {
                setError(err);
                setLoading(false);
            });
    }, []);

    // Toggle row visibility
    const toggleRow = (rowId) => {
        setExpandedRows((prev) => ({
            ...prev,
            [rowId]: !prev[rowId],
        }));
    };


    // Calculate passbook balance
    const calculatePassbookBalance = (passbook, ledgerBook) => {
        let receivedAmount = 0;
        let paidAmount = 0;
        let profitAmount = 0;
        let lossAmount = 0;

        // Calculate Passbook balances
        const updatedPassbook = passbook.map((entry) => {
        if (entry.WonLoss === "" && entry.Credit > 0) {
            receivedAmount += parseFloat(entry.Credit);
            return { ...entry, Bal: receivedAmount };
        }

        if (entry.WonLoss === "" && entry.Debit < 0) {
            paidAmount += parseFloat(entry.Debit);
            return { ...entry, Bal: paidAmount };
        }

        return entry;
        });

        // Calculate Ledger balances
        const updatedLedgerBook = ledgerBook.map((entry) => {
        if (entry.WonLoss === "WON") {
            profitAmount += parseFloat(entry.Debit);
            return { ...entry, Bal: profitAmount };
        }

        if (entry.WonLoss === "LOSS") {
            lossAmount += parseFloat(entry.Credit);
            return { ...entry, Bal: lossAmount };
        }

        return entry;
        });

        // Update states
        setMyPassbook(updatedPassbook);
        setMyLedgerBook(updatedLedgerBook);
        setReceived(receivedAmount);
        setPaid(paidAmount);
        setProfit(profitAmount);
        setLoss(lossAmount);

        console.log(`Received=${receivedAmount}, Paid=${paidAmount}`);
    };

    // Render loading or error state
    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    return (
        <section className="accountste match-content">
            <div className="table_tittle" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white'}}>Passbook</div>
            <div className="table-responsive sports-tabel">
                <div className="passbookTable">
                    <table className="table table-hover table-bordered table-striped" style={{fontSize:'14px',padding:'0px',margin:'0px'}}>
                        <tbody>
                            <tr className="odd collapsed" data-target="#info_1" data-toggle="collapse" aria-expanded="false">
                                <td className="font-bold">Amount Received</td>
                                <td align="right" className="font-bold" style={{color: 'green'}}>{Received} SHOW</td>
                            </tr>
                            <tr>
                                <td className="hidden-row paddingNone" colSpan="2">
                                    <div className="collapse" id="info_1" aria-expanded="false" style={{height: '0px'}}>
                                        <table className="table table-condensed table-sm small showHideInnerTable" style={{fontSize:'14px'}}>
                                            <tbody>
                                                <tr>
                                                    <td className="font-bold">Transaction ID</td>
                                                    <td className="font-bold">Particular</td>
                                                    <td className="font-bold">Date &amp; Time</td>
                                                    <td className="font-bold">Credit</td>
                                                    <td className="font-bold">Balance</td>
                                                </tr>
                                                {MyPassbook.filter((row) => row.WonLoss === '' && row.Credit > 0).map((row, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td> {row.Remark} </td>
                                                    <td>{new Date(row.DateTime).toLocaleString()}</td>
                                                    <td>{row.Credit}</td>
                                                    <td>{row.Bal}</td>
                                                </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>

                            <tr className="even" data-target="#info_2" data-toggle="collapse">
                                <td className="font-bold">Match Loss</td>
                                <td align="right" className="font-bold" style={{color: 'red'}}>{Loss} SHOW</td>
                            </tr>
                            <tr>
                                <td className="hidden-row paddingNone" colSpan="2">
                                    <div className="collapse" id="info_2">
                                        <table className="table table-condensed table-sm small">
                                            <tbody>
                                                <tr>
                                                    <td className="font-bold">S.No.</td>
                                                    <td className="font-bold">Match Detail</td>
                                                    <td className="font-bold">Loss Amount</td>
                                                    <td className="font-bold">Balance</td>
                                                </tr>
                                                
                                                {MyLedgerBook.filter((row) => row.WonLoss == 'LOSS').map((row, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td> {row.Remark} {new Date(row.DateTime).toLocaleString()}</td>
                                                    <td>{row.Credit}</td>
                                                    <td>{row.Bal}</td>
                                                </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                            <tr className="odd" data-target="#info_3" data-toggle="collapse">
                                <td className="font-bold">Match Profit</td>
                                <td align="right" className="font-bold" style={{color: 'green'}}>{Profit} SHOW</td>
                            </tr>
                            <tr>
                                <td className="hidden-row paddingNone" colSpan="2">
                                    <div className="collapse" id="info_3">
                                        <table className="table table-condensed table-sm small">
                                            <tbody>
                                                <tr>
                                                    <td className="font-bold">S.No.</td>
                                                    <td className="font-bold">Match Detail</td>
                                                    <td className="font-bold">Profit Amount</td>
                                                    <td className="font-bold">Balance</td>
                                                </tr>
                                                {MyLedgerBook.filter((row) => row.WonLoss == 'WON').map((row, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td> {row.Remark} {new Date(row.DateTime).toLocaleString()}</td>
                                                    <td>{row.Credit}</td>
                                                    <td>{row.Bal}</td>
                                                </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                            <tr className="even" data-target="#info_4" data-toggle="collapse">
                                <td className="font-bold">Amount Paid</td>
                                <td align="right" className="font-bold" style={{color: 'red'}}>{Paid} SHOW</td>
                            </tr>
                            <tr>
                                <td className="hidden-row paddingNone" colSpan="2">
                                    <div className="collapse" id="info_4">
                                        <table className="table table-condensed table-sm small">
                                            <tbody>
                                                <tr>
                                                    <td className="font-bold">Transaction ID</td>
                                                    <td className="font-bold">Particular</td>
                                                    <td className="font-bold">Date &amp; Time</td>
                                                    <td className="font-bold">Dedit</td>
                                                    <td className="font-bold">Balance</td>
                                                </tr>
                                                {MyLedgerBook.filter((row) => row.WonLoss=='' && row.Debit<0).map((row, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td> {row.Remark} {new Date(row.DateTime).toLocaleString()}</td>
                                                    <td>{row.Credit}</td>
                                                    <td>{row.Bal}</td>
                                                </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                            
                        </tbody>
                    </table>
                    
                    
                </div>
            </div>
        </section>
    );
}

export default Passbook;
